import { useEffect, useState } from "react";
import { Select } from "antd";
import { SelectPair } from "../../types/common.types";
import { useTranslation } from "react-i18next";
import { useLazyGetPracticeStatusTypesQuery } from "../../redux/apiSpecifications/apiCrud";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const AutocompletePracticeStatusWrapper = styled.div`
  flex: 1;

  .select-appraiser-label {
    // text-transform: uppercase;
    font-size: 0.9em;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
`;

const SelectStyled = styled(Select)`
  width: 100%;
  margin-bottom: 2em;
`;

interface IAutocompletePracticeStatusProps {
  onSelect: (practiceStatusCode: string) => void;
}

const AutocompletePracticeStatus = ({
  onSelect,
}: IAutocompletePracticeStatusProps) => {
  const { t } = useTranslation();

  const { authorization } = useSelector((state: RootState) => state.user);

  const [getPracticeStatusTypes] = useLazyGetPracticeStatusTypesQuery();

  const [options, setOptions] = useState<SelectPair[] | undefined>(undefined);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const response = await getPracticeStatusTypes({
      authorization: authorization,
    });

    if (response.isSuccess) {
      const practiceStatusCodeList = response.data as string[];

      const _options = practiceStatusCodeList
        .map((code) => ({
          value: code,
          label: t(`appraisal-statuses-${code}`),
        }))
        .slice()
        .sort((a, b) => (a.label > b.label ? 1 : -1));

      setOptions([{ value: "", label: "" }, ..._options]);
    } else {
      setOptions([]);
    }
  };

  const handleFilterSearchLabel = (input: string, option: any) => {
    return option.children[0].toLowerCase().indexOf(input.toLowerCase()) > -1;
  };

  const handleOnSelectPracticeStatus = (index: string) => {
    const iId = parseInt(index);

    const _practiceStatus = options![iId];

    onSelect(_practiceStatus.value);
  };

  return (
    <AutocompletePracticeStatusWrapper>
      <div className="select-appraiser-label">
        {t("appraisals-details-tab-details-appraisals-status-label")}
      </div>

      <SelectStyled
        optionLabelProp="children"
        showSearch
        filterOption={handleFilterSearchLabel}
        onChange={(index) => handleOnSelectPracticeStatus(index as string)}
        disabled={options === undefined}
      >
        {options?.map((item, i) => (
          <Select.Option key={i}>{item.label} </Select.Option>
        ))}
      </SelectStyled>
    </AutocompletePracticeStatusWrapper>
  );
};

export default AutocompletePracticeStatus;
